import { isAxiosError } from 'shared/api/isAxiosError'

export class ApiError extends Error {
  traceId?: string

  status?: number

  code?: string

  details?: unknown

  constructor(message: string, opts?: {
    traceId?: string
    status?: number
    code?: string
    details?: unknown
  }) {
    super(message)
    this.traceId = opts?.traceId
    this.status = opts?.status
    this.code = opts?.code
    this.details = opts?.details
  }
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError
}

function hasMessage(e: unknown): e is { message: string } {
  return typeof e === 'object'
    && e !== null
    && 'message' in e
    && typeof (e as any).message === 'string'
}

export function getErrorMessage(err: unknown): string {
  if (isAxiosError(err)) {
    return err.message ?? 'Something went wrong.'
  }
  if (isApiError(err)) return err.message
  if (err instanceof Error) return err.message
  if (typeof err === 'string') return err
  if (hasMessage(err)) return err.message
  return 'Something went wrong.'
}
